import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import { TiptapVuetifyPlugin } from 'tiptap-vuetify'

// const vuetify = new Vuetify()

Vue.use(Vuetify);
// Vue.use(TiptapVuetifyPlugin, {
//   // the next line is important! You need to provide the Vuetify Object to this place.
//   vuetify, // same as "vuetify: vuetify"
//   // optional, default to 'md' (default vuetify icons before v2.0.0)
//   iconsGroup: 'md'
// })

export default new Vuetify({
    icons: {
        iconfont: 'mdi', // default - only for display purposes
    },
    theme: {
      themes: {
        light: {
          primary: '#ffee00',
          secondary: '#000846',
          info: '#888',
          error: '#b71c1c',
        },
      },
    },
});
